import React, { Fragment, useContext } from "react";
import classNames from "classnames";

import * as styles from "./utils/elements.module.scss";

const Modal = (props) => {
  const modalBody = props.isCard ? (
    <ModalCardBody {...props} />
  ) : (
    <ModalBody {...props} />
  );

  return (
    <div
      className={classNames("modal m-0", {
        "is-active": props.isModalActive,
        "is-hidden-mobile": props.hideOnMobile,
      })}
    >
      <div
        role="button"
        // onKeyDown={(event) => {
        //   if (event.key === "Enter") props.closeModal()
        // }}
        aria-label="Modal Background"
        tabIndex={0}
        className={`modal-background has-background-${props.modalBackground?.color} has-opacity-${props.modalBackground?.opacity}`}
        onClick={() => {
          if (props.closeOnClickOutside) props.closeModal();
        }}
      ></div>
      {modalBody}
    </div>
  );
};

const ModalCardBody = (props) => (
  <div
    className={classNames("modal-card p-0", props.modalClass, {
      [styles["modal__cardFullheight"]]: props.isFullheight,
    })}
  >
    {props.heading && (
      <div
        className={classNames(
          "modal-card-head",
          props.modalHeaderClass,
          {
            "has-background-white": !props.modalHeaderClass,
          },
          { [styles["modal__cardHeaderFullheight"]]: props.isFullheight }
        )}
      >
        <p className={classNames("modal-card-title", props.modalHeaderClass)}>
          {props.heading}
        </p>
        {!props.hideCloseButton && (
          <button
            className={classNames("delete-bulma is-medium", styles.modalDelete)}
            onClick={props.closeModal}
          >
            Close
          </button>
        )}
      </div>
    )}
    <div
      className={classNames(
        "modal-card-body has-text-centered",
        styles["modal__cardBody"]
      )}
    >
      {props.children}
    </div>
  </div>
);

const ModalBody = (props) => (
  <Fragment>
    {!props.hideCloseButton && (
      <button className="modal-close is-large" onClick={props.closeModal}>
        Close
      </button>
    )}
    <div
      className={classNames(
        "modal-content has-text-centered",
        styles["modal__scrollbarIsHidden"]
      )}
    >
      {props.children}
    </div>
  </Fragment>
);

export default Modal;
